/* src/routes/news/[id].svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	check_outros,
	claim_component,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "../../../web_modules/svelte/internal.js";

import { single } from "./preload.js";
import { News } from "../../../_modules/news/index.js";
import { Car } from "../../../_modules/car/index.js";
import { extractDescription } from "../../../_modules/view/index.js";
import Page from "../../../_components/slot/Page.js";
import Wrap from "../../../_components/slot/Wrap.js";
import Section from "../../../_components/slot/Section.js";
import List from "../../../_components/list/List.js";
import Item from "../../../_components/list/Item.js";
import Title from "../../../_components/block/Title.js";
import Article from "../../../_components/news/Article.js";
import NewsLink from "../../../_components/news/Link.js";
import CarLink from "../../../_components/car/Link.js";
import CTA from "../../../_components/block/CTA.js";
import CTContact from "../../../_components/block/CTContact.js";
import Head from "../../../_components/meta/Head.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (26:314) <Wrap>
function create_default_slot_12(ctx) {
	let article;
	let current;
	article = new Article({ props: { news: /*newsItem*/ ctx[0] } });

	return {
		c() {
			create_component(article.$$.fragment);
		},
		l(nodes) {
			claim_component(article.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(article, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const article_changes = {};
			if (dirty & /*newsItem*/ 1) article_changes.news = /*newsItem*/ ctx[0];
			article.$set(article_changes);
		},
		i(local) {
			if (current) return;
			transition_in(article.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(article.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(article, detaching);
		}
	};
}

// (26:294) <Section kind="top">
function create_default_slot_11(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, newsItem*/ 513) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (26:475) <Item columns="4">
function create_default_slot_10(ctx) {
	let newslink;
	let current;
	newslink = new NewsLink({ props: { newsItem: /*item*/ ctx[4] } });

	return {
		c() {
			create_component(newslink.$$.fragment);
		},
		l(nodes) {
			claim_component(newslink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(newslink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const newslink_changes = {};
			if (dirty & /*news*/ 2) newslink_changes.newsItem = /*item*/ ctx[4];
			newslink.$set(newslink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(newslink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(newslink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(newslink, detaching);
		}
	};
}

// (26:455) {#each news as item}
function create_each_block_1(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "4",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, news*/ 514) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (26:449) <List>
function create_default_slot_9(ctx) {
	let each_1_anchor;
	let current;
	let each_value_1 = /*news*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 2) {
				each_value_1 = /*news*/ ctx[1];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (26:443) <Wrap>
function create_default_slot_8(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, news*/ 514) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (26:374) <Section name="その他のお知らせ" en="NEWS" more="{['/news', 'すべてのお知らせを見る']}">
function create_default_slot_7(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, news*/ 514) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (26:570) <Section background="/images/back_online.jpg" kind="gapless">
function create_default_slot_6(ctx) {
	let cta;
	let current;

	cta = new CTA({
			props: {
				name: "オンライン接客<br>実施中",
				overview: "ご来店が難しい方や不安な方のために、ビデオ通話によるオンライン接客を行っております。",
				action: "/online-service",
				color: "blue",
				position: "left"
			}
		});

	return {
		c() {
			create_component(cta.$$.fragment);
		},
		l(nodes) {
			claim_component(cta.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(cta, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(cta.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(cta.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(cta, detaching);
		}
	};
}

// (26:788) <Section background="/images/back_contact.jpg" kind="gapless">
function create_default_slot_5(ctx) {
	let ctcontact;
	let current;

	ctcontact = new CTContact({
			props: { color: "red", position: "right" }
		});

	return {
		c() {
			create_component(ctcontact.$$.fragment);
		},
		l(nodes) {
			claim_component(ctcontact.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(ctcontact, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(ctcontact.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ctcontact.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(ctcontact, detaching);
		}
	};
}

// (26:1043) <Item columns="432">
function create_default_slot_4(ctx) {
	let carlink;
	let current;
	carlink = new CarLink({ props: { car: /*item*/ ctx[4] } });

	return {
		c() {
			create_component(carlink.$$.fragment);
		},
		l(nodes) {
			claim_component(carlink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(carlink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const carlink_changes = {};
			if (dirty & /*cars*/ 4) carlink_changes.car = /*item*/ ctx[4];
			carlink.$set(carlink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(carlink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(carlink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(carlink, detaching);
		}
	};
}

// (26:1023) {#each cars as item}
function create_each_block(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "432",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, cars*/ 516) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (26:1017) <List>
function create_default_slot_3(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*cars*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*cars*/ 4) {
				each_value = /*cars*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (26:1011) <Wrap>
function create_default_slot_2(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, cars*/ 516) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (26:912) <Section name="車両" en="STOCK" more="{['/stock', 'すべての車両を見る']}" background="/images/back_stock.jpg">
function create_default_slot_1(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, cars*/ 516) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (26:214) <Page>
function create_default_slot(ctx) {
	let title;
	let section0;
	let section1;
	let section2;
	let section3;
	let section4;
	let current;

	title = new Title({
			props: {
				title: "お知らせ",
				en: "NEWS",
				background: "/images/back_stock.jpg"
			}
		});

	section0 = new Section({
			props: {
				kind: "top",
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				name: "その他のお知らせ",
				en: "NEWS",
				more: ["/news", "すべてのお知らせを見る"],
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				background: "/images/back_online.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				background: "/images/back_contact.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				name: "車両",
				en: "STOCK",
				more: ["/stock", "すべての車両を見る"],
				background: "/images/back_stock.jpg",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(title.$$.fragment);
			create_component(section0.$$.fragment);
			create_component(section1.$$.fragment);
			create_component(section2.$$.fragment);
			create_component(section3.$$.fragment);
			create_component(section4.$$.fragment);
		},
		l(nodes) {
			claim_component(title.$$.fragment, nodes);
			claim_component(section0.$$.fragment, nodes);
			claim_component(section1.$$.fragment, nodes);
			claim_component(section2.$$.fragment, nodes);
			claim_component(section3.$$.fragment, nodes);
			claim_component(section4.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(title, target, anchor);
			mount_component(section0, target, anchor);
			mount_component(section1, target, anchor);
			mount_component(section2, target, anchor);
			mount_component(section3, target, anchor);
			mount_component(section4, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const section0_changes = {};

			if (dirty & /*$$scope, newsItem*/ 513) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope, news*/ 514) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 512) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 512) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const section4_changes = {};

			if (dirty & /*$$scope, cars*/ 516) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
		},
		i(local) {
			if (current) return;
			transition_in(title.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(title.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(title, detaching);
			destroy_component(section0, detaching);
			destroy_component(section1, detaching);
			destroy_component(section2, detaching);
			destroy_component(section3, detaching);
			destroy_component(section4, detaching);
		}
	};
}

function create_fragment(ctx) {
	let head;
	let page;
	let current;

	head = new Head({
			props: {
				title: "" + (/*newsItem*/ ctx[0].title + " | 株式会社アルベロ | 群馬県の輸入車販売店"),
				path: "/news/" + /*newsItem*/ ctx[0].slug,
				description: /*newsItem*/ ctx[0].excerpt || /*excerpt*/ ctx[3],
				image: /*newsItem*/ ctx[0].featuredImage?.getSized("large") || "/images/keyvisual.jpg"
			}
		});

	page = new Page({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(head.$$.fragment);
			create_component(page.$$.fragment);
		},
		l(nodes) {
			claim_component(head.$$.fragment, nodes);
			claim_component(page.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(head, target, anchor);
			mount_component(page, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const head_changes = {};
			if (dirty & /*newsItem*/ 1) head_changes.title = "" + (/*newsItem*/ ctx[0].title + " | 株式会社アルベロ | 群馬県の輸入車販売店");
			if (dirty & /*newsItem*/ 1) head_changes.path = "/news/" + /*newsItem*/ ctx[0].slug;
			if (dirty & /*newsItem*/ 1) head_changes.description = /*newsItem*/ ctx[0].excerpt || /*excerpt*/ ctx[3];
			if (dirty & /*newsItem*/ 1) head_changes.image = /*newsItem*/ ctx[0].featuredImage?.getSized("large") || "/images/keyvisual.jpg";
			head.$set(head_changes);
			const page_changes = {};

			if (dirty & /*$$scope, cars, news, newsItem*/ 519) {
				page_changes.$$scope = { dirty, ctx };
			}

			page.$set(page_changes);
		},
		i(local) {
			if (current) return;
			transition_in(head.$$.fragment, local);
			transition_in(page.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(head.$$.fragment, local);
			transition_out(page.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(head, detaching);
			destroy_component(page, detaching);
		}
	};
}

const preload = single;

function instance($$self, $$props, $$invalidate) {
	let { newsItem } = $$props;
	let { news = [] } = $$props;
	let { cars = [] } = $$props;

	const excerpt = newsItem.content
	? extractDescription(newsItem.content)
	: "";

	$$self.$$set = $$props => {
		if ("newsItem" in $$props) $$invalidate(0, newsItem = $$props.newsItem);
		if ("news" in $$props) $$invalidate(1, news = $$props.news);
		if ("cars" in $$props) $$invalidate(2, cars = $$props.cars);
	};

	return [newsItem, news, cars, excerpt];
}

class U5Bidu5D extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { newsItem: 0, news: 1, cars: 2 });
	}
}

export default U5Bidu5D;
export { preload };
//# sourceMappingURL=[id].js.map
